import React, { createContext, useContext, useEffect, useState } from 'react';
import { settingsService, SystemSettings } from '../services/settingsService';

interface SettingsContextValue {
  settings: SystemSettings | null;
  refresh: () => Promise<void>;
  update: (data: Partial<SystemSettings>) => Promise<void>;
}

const SettingsContext = createContext<SettingsContextValue | undefined>(undefined);

export const SettingsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [settings, setSettings] = useState<SystemSettings | null>(null);

  const refresh = async () => {
    const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
    if (!token) { setSettings(null); return; }
    try { setSettings(await settingsService.get()); } catch { /* ignore */ }
  };

  const update = async (data: Partial<SystemSettings>) => {
    const next = await settingsService.update(data);
    setSettings(next);
  };

  useEffect(() => { refresh(); }, []);

  return (
    <SettingsContext.Provider value={{ settings, refresh, update }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const ctx = useContext(SettingsContext);
  if (!ctx) throw new Error('useSettings must be used within SettingsProvider');
  return ctx;
};

